/** Internal dependencies */
import { fetchHandler } from '../../../../../../assets/src/scripts/utilities/fetchHandler';

export const coupons = {
    parentEl: document.querySelector('.ct_woocommercecheckout'),
    checkoutParams: null,

    init: function () {
        this.submit = this.submit.bind(this);
        this.removeCoupon = this.removeCoupon.bind(this);

        this.checkoutParams = this.parentEl ? JSON.parse(this.parentEl.dataset.wcCheckoutParams) : null;

        document.body.addEventListener('click', this.showCouponForm);
        document.body.addEventListener('click', this.removeCoupon);

        const checkoutCoupon = document.querySelector('form.checkout_coupon');
        if (checkoutCoupon) {
            checkoutCoupon.classList.add('d-none');
            checkoutCoupon.addEventListener('submit', this.submit);
        }
    },

    showCouponForm(e) {
        const target = e.target;

        if (!target.matches('a.showcoupon')) {
            return;
        }

        const couponForm = document.querySelector('.checkout_coupon');

        if (couponForm.classList.contains('d-none')) {
            couponForm.classList.remove('d-none');
            const firstInput = couponForm.querySelector('input');
            firstInput && firstInput.dispatchEvent(new Event('focus'));
        } else {
            couponForm.classList.add('d-none');
        }

        return false;
    },

    submit: function (e) {
        const form = e.target;

        if (form.classList.contains('processing')) {
            return false;
        }

        form.classList.add('processing');

        // todo: maybe block form
        const data = {
            action: 'applyCoupon',
            security: this.checkoutParams.applyCouponNonce,
            couponCode: form.querySelector('input[name="coupon_code"]')?.value,
        };

        const fetchOptions = {
            url: this.checkoutParams.ajaxUrl,
            method: 'POST',
            body: new URLSearchParams(data),
        };
        const applyCoupon = fetchHandler(fetchOptions);
        applyCoupon
            .then((result) => {
                const noticeContainer = document.querySelector('.ct_woocommercenotices.default');
                if (noticeContainer) {
                    const notices = document.querySelectorAll('.ct_woocommercenotices .alert');
                    notices && notices.forEach((notice) => notice.remove());
                } else {
                    const tempNoticeContainer = document.querySelectorAll('.temp-notice-container');
                    tempNoticeContainer && tempNoticeContainer.forEach((container) => container.remove());
                }
                form.classList.remove('processing');
                if (noticeContainer) {
                    noticeContainer.insertAdjacentHTML('beforeend', result.message);
                } else {
                    const div = document.createElement('div');
                    div.classList.add('temp-notice-container');
                    div.innerHTML = result.message;
                    form.parentNode.insertBefore(div, form);
                }
                form.classList.add('d-none');
                document.body.dispatchEvent(
                    new CustomEvent('appliedCouponInCheckout', { detail: { data: data.couponCode } })
                );
                document.body.dispatchEvent(
                    new CustomEvent('updateCheckout', {
                        detail: {
                            updateShippingMethod: false,
                        },
                    })
                );
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                if (window.lazyLoadInstance) {
                    window.lazyLoadInstance.update();
                }
            });

        // prevent default submit action
        return false;
    },

    removeCoupon(e) {
        const target = e.target;

        if (!target.matches('.woocommerce-remove-coupon')) {
            return;
        }

        e.preventDefault();

        const container = target.closest('.woocommerce-checkout-review-order');
        const coupon = target.dataset.coupon;
        container.classList.add('processing');
        const data = {
            action: 'removeCoupon',
            security: this.checkoutParams.removeCouponNonce,
            coupon,
        };
        const fetchOptions = {
            url: this.checkoutParams.ajaxUrl,
            method: 'POST',
            body: new URLSearchParams(data),
        };
        const remove = fetchHandler(fetchOptions);
        remove
            .then((result) => {
                const noticeContainer = document.querySelector('.ct_woocommercenotices.default');

                if (noticeContainer) {
                    const notices = document.querySelectorAll('.ct_woocommercenotices .alert');
                    notices && notices.forEach((notice) => notice.remove());
                } else {
                    const tempNoticeContainer = document.querySelectorAll('.temp-notice-container');
                    tempNoticeContainer && tempNoticeContainer.forEach((container) => container.remove());
                }

                container.classList.remove('processing');

                if (result) {
                    if (noticeContainer) {
                        noticeContainer.insertAdjacentHTML('beforeend', result.message);
                    } else {
                        const div = document.createElement('div');
                        div.classList.add('temp-notice-container');
                        div.innerHTML = result.message;
                        container.parentNode.insertBefore(div, container);
                    }

                    document.body.dispatchEvent(
                        new CustomEvent('removedCouponInCheckout', {
                            detail: {
                                data: data.couponCode,
                            },
                        })
                    );
                    document.body.dispatchEvent(
                        new CustomEvent('updateCheckout', {
                            detail: {
                                updateShippingMethod: false,
                            },
                        })
                    );

                    // Remove coupon code from coupon field
                    const couponField = document.querySelector('form.checkout_coupon input[name="coupon_code"]');
                    if (couponField) {
                        couponField.value = '';
                    }
                }
            })
            .catch((e) => {
                if (this.checkoutParams.debugMode) {
                    console.log(e);
                }
            })
            .finally(() => {
                if (window.lazyLoadInstance) {
                    window.lazyLoadInstance.update();
                }
            });
    },
};
